import { IPagination, IPartyV1 } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	filter: { id?: string } & IPagination
	include?: { details?: boolean; stats?: boolean }
}

interface ResponseDataShape {
	success: boolean
	data: IPartyV1[]
}

export async function partyListApi(payload: RequestDataShape, token?: null | string) {
	const endpoint = "/party/list/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response.data
}
